module.exports = __webpack_public_path__ + "static/364086_1_0-d27c8248242e21bd9b00f38fa4486676.woff2";